export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangePortalOwner.json?hash=065501b79444dde3351a95269731c6ed";